import {
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';

export class PosCoveredV2 {
  id: number = 0;
  code: string = '';
  name: string = '';

  constructor(data: Partial<PosCoveredV2> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.code = StringOrNullOrUndefined(data.code) ?? '';
    this.name = StringOrNullOrUndefined(data.name) ?? '';
  }
}
